import { Navigate } from 'react-router-dom';

import useDefaultRedirect from 'hooks/useDefaultRedirect';

const HomeRedirect = () => {
  const redirectTo = useDefaultRedirect();

  return <Navigate to={redirectTo} replace />;
};

export default HomeRedirect;
